import { LS2KIDS_CONSTANTS } from "../constants";
import { KidsThemeActor } from "./Actor";

export class KidsBaseTheme {

	constructor(options) {
		this.name = options.name;
		this.imagesPath = options.imagesPath;
		this.themeClass = 'ls2kids-theme';
		this.themeClassPrefix = this.themeClass + '-';

		this.addElements();

		if (options.background) {
			this.addBackgroundElements(options.background);
		}

		this.app = $('#' + LS2KIDS_CONSTANTS.Ids.app);

		this.appWidth = this.app.width();
		this.appHeight = this.app.height();

		this.app.removeClass("loading");
	}
	addElements() {
		this.element = $('<div></div>')
			.attr('id', LS2KIDS_CONSTANTS.Ids.activeTheme)
			.addClass(this.themeClassPrefix + this.name)
			.addClass(this.themeClass)
			.insertAfter('#' + LS2KIDS_CONSTANTS.Ids.app);
	}
	addBackgroundElements(types) {
		if (typeof types === 'string') {
			types = [types];
		}

		this.backgroundActors = {};

		for (var i = 0, len = types.length; i < len; i += 1) {
			var type = types[i];

			this.backgroundActors[type] = new KidsThemeActor(this, type, {
				wrap: this.name + "-background-wrap" + " " + type + "-wrap"
			});
		}
	}
}



